import axios from '@/libs/axios'

export class GeofenceService {


  static async getGeofenceById(id) {
    return new Promise((resolve, reject) => {
      axios.get(`geofence/${id}`)
        .then(res => resolve(res.data.data))
        .catch(reason => reject(reason.response))
    })
  }

  static async getAllGeofence(params) {
    return new Promise((resolve, reject) => {
     // console.log('cvcvcv')
      axios.get(`fetch_areas_to_draw`)
        .then(res => resolve(res.data.areas))
        .catch(reason => reject(reason.response))
    })
  }
  static async getGeofenceTypesByCategory(category) {
    return new Promise((resolve, reject) => {
      
      axios.get('types?category='+category)
        .then(res => resolve(res))
        .catch(reason => reject(reason))
    })
  }

  static async createGeofence(data) {
    return new Promise((resolve, reject) => {
      axios.post(`geofence`, data)
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }


  static async updateGeofence(id, data) {
    return new Promise((resolve, reject) => {
      axios.put(`geofence/${id}`, data)
        .then(res => resolve(res.data.device))
        .catch(reason => reject(reason.response))
    })
  }



  static async deleteGeofence(id) {
    return new Promise((resolve, reject) => {
      axios.delete(`geofence/${id}`)
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }

}
